import React, { useEffect, useState } from 'react'

import { AuthenticatedTemplate, useMsal } from '@azure/msal-react'
import { useTranslation } from 'react-i18next'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import Modal from '../../components/Modal'
import useCurrentWidth from '../../customHooks/resizeWindowHook'
import { Footer, Header, PageHeading, SideBar } from './components'
import './index.scss'
import RouteTracker from './components/RouteTracker'
import { setPageHeader } from '../../services/title.service'
import { Breadcrumb } from './components/Breadcrumb'
import useFooterHeight from '../../customHooks/footerHeightHook'
import Freshchat from '../../components/Freshchat'
import { shouldLoadFreshchat } from '../../services/freshchat.service'

const LayoutWrapper = () => {
  const isMobile = useCurrentWidth()
  const location = useLocation()
  const footerHeight = useFooterHeight()

  const { t } = useTranslation()
  const navigate = useNavigate()
  const [showLogoutModal, setShowLogoutModal] = useState(false)
  const [open, setOpen] = useState(false)
  const [loadFreshchat, setLoadFreshchat] = useState(false)

  const { instance } = useMsal()

  const { pageHeading, headingHeader, redirectLink } = setPageHeader(location.pathname)

  useEffect(() => {
    shouldLoadFreshchat().then(setLoadFreshchat)
  }, [])

  useEffect(() => {
    if (isMobile) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }, [isMobile])

  useEffect(() => {
    setShowLogoutModal(false)
    if (isMobile) {
      setOpen(false)
    }
  }, [location])

  const onLogoutAction = (action: string) => {
    if (action === 'logout') {
      instance.logout()
      setShowLogoutModal(false)
    } else {
      setShowLogoutModal(false)
      navigate('/')
    }
  }

  const isHomePage = location.pathname === '/' ? true : false

  return (
    <>
    <RouteTracker />
    <div className={`layout-wrapper ${isMobile ? 'mobile' : ''}`}>
      <AuthenticatedTemplate>
        <div className='navbar-wrapper'>
          <SideBar
            open={open}
            isMobile={isMobile}
            setOpen={setOpen}
            setLogoutModal={() => setShowLogoutModal(true)}
          />
        </div>
      </AuthenticatedTemplate>
      <main className='main-wrapper'>
        {showLogoutModal && (
          <Modal
            head={`${t('LOG_OUT.LOG_OUT')}`}
            text={`${t('LOG_OUT.ARE_YOU_SURE')}`}
            confirmText={`${t('BUTTON.YES')}`}
            cancelText={`${t('BUTTON.NO')}`}
            zIndex={1000}
            onConfirm={() => onLogoutAction('logout')}
            onCancel={() => onLogoutAction('cancel')}
          />
        )}
        {headingHeader && redirectLink && (
          <Header heading={headingHeader} redirectLink={redirectLink} />
        )}
        <Breadcrumb pathname={location.pathname} />
        <div className='background-holder'></div>
        <div
          className='main-content-wrapper wrapper'
          style={{
            paddingBottom: `${footerHeight + 70}px`
          }}
        >
          {pageHeading && (
            <PageHeading page={pageHeading} />
          )}
          <div role='main'>
            <Outlet />
          </div>
          {isHomePage && (
            <p
              className='aroundtown_intro'
              role='complementary'
            >
              <Link
                style={{textTransform: 'uppercase'}}
                target='_blank'
                rel="noreferrer"
                to='https://www.aroundtown.de/'
                role='link'
                aria-label={String(t('HOME.AROUNDTOWN_INTRO_LINK'))}
              >
                {t('HOME.AROUNDTOWN_INTRO_LINK')}
              </Link>
              {t('HOME.AROUNDTOWN_INTRO')}
            </p>
          )}
        </div>
      </main>
      <AuthenticatedTemplate>
        <Footer />
        {loadFreshchat && <Freshchat />}
      </AuthenticatedTemplate>
    </div>
    </>
  )
}

export default LayoutWrapper
